import { useState } from "react";
import { Menu, ShoppingBag, X } from "lucide-react";

const LINKS = [
  ["Collection", "#collection"],
  ["Manifeste", "#manifeste"],
  ["Atelier", "#atelier"],
  ["Broderies", "#broderies"],
  ["Contact", "#contact"],
];

export default function Nav({ cartCount, onCartOpen, onNavigate }) {
  const [open, setOpen] = useState(false);

  const go = (hash) => {
    setOpen(false);
    onNavigate(hash);
  };

  return (
    <header
      data-testid="main-nav"
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#0C0D0E]/85 border-b border-[#E2DBCB]/10 shadow-[0_4px_30px_rgba(0,0,0,0.3)]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12 h-[72px] flex items-center justify-between">
        <button
          data-testid="nav-brand"
          onClick={() => go("#top")}
          className="font-serif text-xl tracking-wide text-[#F7F5F0] hover:text-[#D4AF37] transition-colors"
        >
          Tarantina <span className="italic text-[#C5A059]">Kimono</span>
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map(([label, hash]) => (
            <button
              key={hash}
              data-testid={`nav-link-${label.toLowerCase().replace("é", "e")}`}
              onClick={() => go(hash)}
              className="text-xs uppercase tracking-[0.2em] font-mono text-[#B0ABA0] hover:text-[#D4AF37] transition-colors"
            >
              {label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="cart-toggle-btn"
            onClick={onCartOpen}
            className="relative flex items-center gap-2 rounded-full border border-[#E2DBCB]/15 px-4 py-2 text-xs font-mono uppercase tracking-widest text-[#F7F5F0] hover:border-[#D4AF37]/50 hover:text-[#D4AF37] transition-colors"
          >
            <ShoppingBag size={15} />
            <span className="hidden sm:inline">Panier</span>
            {cartCount > 0 && (
              <span
                data-testid="cart-count-badge"
                className="absolute -top-2 -right-2 flex h-5 w-5 items-center justify-center rounded-full bg-[#D4AF37] text-[10px] font-semibold text-[#0C0D0E]"
              >
                {cartCount}
              </span>
            )}
          </button>
          <button
            data-testid="nav-menu-btn"
            onClick={() => setOpen(!open)}
            className="md:hidden text-[#F7F5F0]"
            aria-label="Menu"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="md:hidden border-t border-[#E2DBCB]/10 bg-[#0C0D0E]/95 px-6 py-6 flex flex-col gap-5"
        >
          {LINKS.map(([label, hash]) => (
            <button
              key={hash}
              data-testid={`nav-mobile-link-${label.toLowerCase().replace("é", "e")}`}
              onClick={() => go(hash)}
              className="text-left text-sm uppercase tracking-[0.2em] font-mono text-[#B0ABA0] hover:text-[#D4AF37] transition-colors"
            >
              {label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
}
